<template>
  <div class="gptConfig-page">
    <tabHeader
      :slideData="slideData"
      :tab="tab"
      @headerTabBack="headerTabBack"
    />
    <transition name="fade-transform" mode="out-in">
      <component :is="tab"></component>
    </transition>
  </div>
</template>

<script>
import tabHeader from '@/components/tabHeader'
import gptPrompt from './gptPrompt'
import gptCondition from './gptCondition'
export default {
  components: {
    gptPrompt,
    gptCondition,
    tabHeader
  },
  computed: {
    slideData() {
      const slideData = [
        {
          name: 'GPT提示语',
          component: 'gptPrompt'
        },
        {
          name: 'GPT条件',
          component: 'gptCondition'
        }
      ]
      return slideData
    }
  },
  data() {
    return {
      tab: 'gptPrompt'
    }
  },
  methods: {
    headerTabBack(tab) {
      this.tab = tab.component
    }
  },
  mounted() {}
}
</script>

<style lang="scss">
.gptConfig-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
